/**
 * UI permission-keys for the `VENDOR` route (Vendors screen).
 * Typed mirror of the BE CSV — confirm strings with the BE. (ENT-89 T15.)
 */
export const VendorAclKeys = {
  /** Access to the /providers (Vendors) listing + detail subtree. */
  listingRead: 'vendors:listing:read',
  /** Onboard Vendor — gates BOTH the launcher button and the /onboarding/vendor route. */
  onboard: 'vendors:onboard',
} as const;

export type VendorAclKey = (typeof VendorAclKeys)[keyof typeof VendorAclKeys];
